import { render } from "./SkeletonReportGroup.vue?vue&type=template&id=199f197c"
import script from "./SkeletonReportGroup.vue?vue&type=script&lang=js"
export * from "./SkeletonReportGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__